import React from 'react';
import { PlxsText } from '@plexlogic/plexus-ui';

const Loading: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        gap: '16px'
      }}
    >
      <div style={{ 
        width: '40px', 
        height: '40px', 
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #0066FF',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
      <PlxsText size="sm">Loading...</PlxsText>
    </div>
  );
};

export default Loading;
